import { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';

const categories = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  { name: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
  { name: 'Pants/Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html' },
  { name: 'Underwear/Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const location = useLocation();
  const isHomepage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const onHero = isHomepage && !isScrolled;

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50 shadow-sm'
          : isHomepage
          ? 'bg-transparent'
          : 'bg-background-50'
      }`}
    >
      <div className="w-full px-4 md:px-8 lg:px-14">
        <div className="flex items-center justify-between h-16 md:h-18">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className={`w-8 h-8 md:w-9 md:h-9 rounded-full flex items-center justify-center transition-colors duration-300 ${
              onHero ? 'bg-background-50' : 'bg-primary-500'
            }`}>
              <i className={`ri-database-2-line text-base md:text-lg w-4 h-4 md:w-5 md:h-5 flex items-center justify-center transition-colors duration-300 ${
                onHero ? 'text-foreground-950' : 'text-background-50'
              }`}></i>
            </span>
            <span className={`font-heading text-base md:text-lg font-bold whitespace-nowrap transition-colors duration-300 ${
              onHero ? 'text-background-50' : 'text-foreground-950'
            }`}>
              Superbuy Sheet
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/superbuy-spreadsheet-database"
              className={`text-sm font-label font-medium transition-colors whitespace-nowrap cursor-pointer ${
                onHero ? 'text-background-50/80 hover:text-background-50' : 'text-foreground-700 hover:text-foreground-950'
              }`}
            >
              DATABASE
            </Link>
            <a
              href="#categories"
              className={`text-sm font-label font-medium transition-colors whitespace-nowrap cursor-pointer ${
                onHero ? 'text-background-50/80 hover:text-background-50' : 'text-foreground-700 hover:text-foreground-950'
              }`}
            >
              CATEGORIES
            </a>
            <Link
              to="/superbuy-spreadsheet-guide"
              className={`text-sm font-label font-medium transition-colors whitespace-nowrap cursor-pointer ${
                onHero ? 'text-background-50/80 hover:text-background-50' : 'text-foreground-700 hover:text-foreground-950'
              }`}
            >
              GUIDES
            </Link>
            <Link
              to="/superbuy-spreadsheet-safety"
              className={`text-sm font-label font-medium transition-colors whitespace-nowrap cursor-pointer ${
                onHero ? 'text-background-50/80 hover:text-background-50' : 'text-foreground-700 hover:text-foreground-950'
              }`}
            >
              SAFETY
            </Link>

            {/* Dropdown */}
            <div className="relative" ref={dropdownRef}>
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className={`flex items-center gap-1.5 px-4 py-2 rounded-md text-sm font-label font-medium transition-colors whitespace-nowrap cursor-pointer bg-transparent ${
                  onHero
                    ? 'border border-background-50/30 text-background-50 hover:border-background-50 hover:text-background-50'
                    : 'border border-foreground-200 text-foreground-700 hover:border-foreground-400 hover:text-foreground-950'
                }`}
              >
                All Categories
                <i className={`ri-arrow-down-s-line text-xs transition-transform duration-200 ${dropdownOpen ? 'rotate-180' : ''} w-3 h-3 flex items-center justify-center`}></i>
              </button>

              {dropdownOpen && (
                <div className="absolute top-full left-0 mt-2 w-56 bg-background-50 border border-background-200 rounded-lg shadow-lg py-2 max-h-80 overflow-y-auto z-50">
                  {categories.map((cat) => (
                    <a
                      key={cat.name}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="block px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors whitespace-nowrap"
                      onClick={() => setDropdownOpen(false)}
                    >
                      {cat.name}
                    </a>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Mobile Hamburger */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden flex items-center justify-center w-10 h-10 rounded-md cursor-pointer"
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl w-5 h-5 flex items-center justify-center transition-colors duration-300 ${
              onHero ? 'text-background-50' : 'text-foreground-950'
            }`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-5 max-h-[80vh] overflow-y-auto">
          {/* Primary Links */}
          <div className="grid grid-cols-2 gap-2 mb-5">
            <Link to="/" className="flex items-center gap-2.5 px-3 py-3 bg-background-100 border border-background-200 rounded-lg hover:border-background-300 transition-colors cursor-pointer" onClick={() => setMobileMenuOpen(false)}>
              <span className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-home-4-line text-primary-600 text-sm w-3.5 h-3.5 flex items-center justify-center"></i>
              </span>
              <span className="text-sm font-label font-semibold text-foreground-900 whitespace-nowrap">Home</span>
            </Link>
            <Link to="/superbuy-spreadsheet-database" className="flex items-center gap-2.5 px-3 py-3 bg-background-100 border border-background-200 rounded-lg hover:border-background-300 transition-colors cursor-pointer" onClick={() => setMobileMenuOpen(false)}>
              <span className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-database-2-line text-accent-600 text-sm w-3.5 h-3.5 flex items-center justify-center"></i>
              </span>
              <span className="text-sm font-label font-semibold text-foreground-900 whitespace-nowrap">Database</span>
            </Link>
            <Link to="/superbuy-spreadsheet-guide" className="flex items-center gap-2.5 px-3 py-3 bg-background-100 border border-background-200 rounded-lg hover:border-background-300 transition-colors cursor-pointer" onClick={() => setMobileMenuOpen(false)}>
              <span className="w-8 h-8 rounded-full bg-secondary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-book-open-line text-secondary-600 text-sm w-3.5 h-3.5 flex items-center justify-center"></i>
              </span>
              <span className="text-sm font-label font-semibold text-foreground-900 whitespace-nowrap">Guides</span>
            </Link>
            <Link to="/superbuy-spreadsheet-safety" className="flex items-center gap-2.5 px-3 py-3 bg-background-100 border border-background-200 rounded-lg hover:border-background-300 transition-colors cursor-pointer" onClick={() => setMobileMenuOpen(false)}>
              <span className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-shield-check-line text-accent-600 text-sm w-3.5 h-3.5 flex items-center justify-center"></i>
              </span>
              <span className="text-sm font-label font-semibold text-foreground-900 whitespace-nowrap">Safety</span>
            </Link>
          </div>

          {/* All Categories Section */}
          <div className="border-t border-background-200 pt-4">
            <div className="flex items-center gap-2 mb-3 px-1">
              <i className="ri-grid-line text-foreground-400 text-xs w-3 h-3 flex items-center justify-center"></i>
              <span className="text-xs font-label font-semibold text-foreground-400 uppercase tracking-wider">All 14 Categories</span>
            </div>
            <div className="grid grid-cols-2 gap-1.5">
              {categories.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="flex items-center gap-2 px-2.5 py-2.5 text-sm text-foreground-700 hover:bg-background-100 rounded-md whitespace-nowrap transition-colors cursor-pointer"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <span className="w-1.5 h-1.5 rounded-full bg-accent-300 flex-shrink-0"></span>
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          {/* External CTA */}
          <div className="mt-4 pt-4 border-t border-background-200">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center justify-center gap-2 w-full px-4 py-3 bg-primary-500 text-background-50 font-label font-semibold text-sm rounded-lg hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              onClick={() => setMobileMenuOpen(false)}
            >
              Visit Kaspreadsheet
              <i className="ri-external-link-line text-sm w-3.5 h-3.5 flex items-center justify-center"></i>
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}